import { http } from './httpClient';
import type { GetSystemEventsResponse } from '../types/event.types';

export const getEvents = async (after?: string): Promise<GetSystemEventsResponse> => {
    const query = after ? `?after=${encodeURIComponent(after)}` : '';
    return await http.get<GetSystemEventsResponse>(`/events${query}`);
};
